module.exports = __webpack_public_path__ + "img/sankaku_38_blue.3b2b6dad.png";